import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CosecHome from "@/pages/CosecHome";
import Landing from "@/pages/Landing";
import FeaturesPage from "@/pages/FeaturesPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import CompanySecretariesPage from "@/pages/CompanySecretariesPage";
import AccountantsPage from "@/pages/AccountantsPage";
import CorporateLawPage from "@/pages/CorporateLawPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import NotFoundPage from "@/pages/NotFoundPage";
import CatalogListPage from "@/pages/CatalogListPage";
import CoSearchPage from "@/pages/CoSearchPage";
import CoSearchFeatureRouter from "@/components/site/CoSearchFeatureRouter";
import CatalogRouter from "@/components/site/CatalogRouter";
import {
  GuidesPage, GlossaryPage, FaqsPage, PartnersPage,
  ComplianceGuidePage, BusinessIntelligencePage, CoformPage,
} from "@/pages/ContentPages";
import AiPage from "@/pages/AiPage";
import AdminMetricsPage from "@/pages/AdminMetricsPage";
import KBPage from "@/pages/KBPage";
import { DynamicProductPage, DynamicSolutionPage } from "@/pages/CmsLandingPages";
import ScrollToTop from "@/components/site/ScrollToTop";
import CookieBanner from "@/components/site/CookieBanner";
import AnalyticsRouteTracker from "@/components/site/AnalyticsRouteTracker";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsRouteTracker />
        <Routes>
          {/* Core */}
          <Route path="/" element={<CosecHome />} />
          <Route path="/cosecapp" element={<FeaturesPage />} />
          <Route path="/features" element={<Navigate to="/cosecapp" replace />} />
          <Route path="/services" element={<CatalogListPage kind="service" />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Internal — token-gated, intentionally not in sitemap */}
          <Route path="/admin/metrics" element={<AdminMetricsPage />} />

          {/* CMS-driven dynamic content (populated when CMS_PROVIDER=strapi) */}
          <Route path="/kb" element={<KBPage />} />
          <Route path="/kb/:slug" element={<KBPage />} />
          <Route path="/products/:slug" element={<DynamicProductPage />} />
          <Route path="/solutions/:slug" element={<DynamicSolutionPage />} />

          {/* Solutions */}
          <Route path="/company-secretaries" element={<CompanySecretariesPage />} />
          <Route path="/accountants" element={<AccountantsPage />} />
          <Route path="/corporate-law" element={<CorporateLawPage />} />

          {/* Content */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/category/:cat" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/glossary" element={<GlossaryPage />} />
          <Route path="/faqs" element={<FaqsPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/company-secretarial-compliance-uk-guide" element={<ComplianceGuidePage />} />

          {/* Standalone products */}
          <Route path="/business-intelligence-platform" element={<BusinessIntelligencePage />} />
          <Route path="/coform" element={<CoformPage />} />
          <Route path="/ai" element={<AiPage />} />
          <Route path="/coverify" element={<Landing />} />
          <Route path="/cosearch" element={<CoSearchPage />} />
          <Route path="/cosearch/:slug" element={<CoSearchFeatureRouter />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />

          {/* Sitemap redirects (legacy URLs from cosecglobal.com) */}
          <Route path="/all-features" element={<Navigate to="/cosecapp" replace />} />
          <Route path="/cosec-pricing" element={<Navigate to="/pricing" replace />} />
          <Route path="/blogs" element={<Navigate to="/blog" replace />} />
          <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
          <Route path="/contact-sales" element={<Navigate to="/contact" replace />} />
          <Route path="/contact-support" element={<Navigate to="/contact" replace />} />
          <Route path="/about-us" element={<Navigate to="/about" replace />} />
          <Route path="/corporate-law-practitioner" element={<Navigate to="/corporate-law" replace />} />
          <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
          <Route path="/terms-and-conditions" element={<Navigate to="/terms" replace />} />

          {/* Catalog-driven service + feature pages */}
          <Route path="/:slug" element={<CatalogRouter />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
